export default __webpack_public_path__ + "images/17a2a4786135df1d0911a4e061e96c8c-Eventbrite_Holiday_HomepageC_1920x544.webp";